// extracted by mini-css-extract-plugin
export default {"container":"container--JEJAN","bubble":"bubble--PkipN","right":"right--cfdTk"};